import { ERROR_CODE } from '@/lib/config/errorCode';
import { SERVER_CODE } from '@/lib/config/serverCode';
import { api } from '@/lib/utils/api.utils';
import { ResponseMap } from '@/lib/utils/api.utils';
import ky from 'ky';
import { useMutation } from '@tanstack/react-query';
import { toaster } from '@/components/ui/toaster';

const requestUrl = process.env.NEXT_PUBLIC_AI_EARN_REQUEST_URL;
export type ApproveDetails = {
  domain: Domain;
  message: Message;
  primaryType: keyof Types;
  types: Types;
};

export type Domain = {
  chainId: number;
  name: string;
  verifyingContract: string;
  version: string;
};

export type Message = {
  agentAddress: string;
  agentName: string;
  hyperliquidChain: string;
  nonce: number;
  signatureChainId: string;
  type: string;
};

export type Types = {
  EIP712Domain: EIP712Domain[];
  'HyperliquidTransaction:ApproveAgent': HyperliquidTransactionApproveAgent[];
};

export type EIP712Domain = {
  name: string;
  type: string;
};

export type HyperliquidTransactionApproveAgent = {
  name: string;
  type: string;
};
export const requestApproveDetails = async () => {
  const response = await ky.get(`${requestUrl}/get_approve_details`);
  if (!response.ok) {
    throw new Error(ERROR_CODE.NETWORK_ERROR);
  }
  const data = await response.json<ResponseMap<ApproveDetails>>();
  if (data.status !== 'success') {
    throw new Error(data.status);
  }
  if (!data.data) {
    throw new Error('data is empty');
  }
  return data.data;
};
export type VaultTransferProps = {
  /**
   * 地址
   */
  address: string;
  /**
   * 转账的数量
   */
  amount: number;
  /**
   * true表示存入，false表示取出
   */
  is_deposit: boolean;
  /**
   * 签名
   */
  signature: string;
  vault_address: string;
};

export type WithdrawalProps = {
  address: string;
  amount: string;
  signature: string;
  nonce: number;
};
export async function requestVaultTransfer(params: VaultTransferProps) {
  const response = await ky.post(`${requestUrl}/vault/transfer`, {
    json: params,
  });
  if (!response.ok) {
    throw new Error(ERROR_CODE.NETWORK_ERROR);
  }
  const data = await response.json<ResponseMap<string>>();
  if (data.status !== 'success') {
    throw new Error(data.status);
  }
  return data.data;
}

export async function requestWithdrawal(params: WithdrawalProps) {
  const response = await ky.post(`${requestUrl}/withdraw_to_arb`, {
    json: params,
  });
  if (!response.ok) {
    throw new Error(ERROR_CODE.NETWORK_ERROR);
  }
  const data = await response.json<ResponseMap<string>>();
  if (data.status !== 'success') {
    throw new Error(data.status);
  }
  return data.data;
}

export function useWithdrawal() {
  return useMutation({
    mutationFn: requestWithdrawal,
    onSuccess: (data) => {
      if (data === 'ok') {
        toaster.create({
          title: 'Withdrawal successful',
          type: 'success',
        });
      } else {
        toaster.create({
          title: 'Withdrawal failed',
          type: 'error',
        });
      }
    },
    onError: () => {
      toaster.create({
        title: 'Withdrawal failed',
        type: 'error',
      });
    },
  });
}
